import useCampaigns from "common/datahooks/useCampaigns";
import usePaymentSource from "common/datahooks/usePaymentSource";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

export default function useOnboardingProgress() {
  const {
    accounts_count: accountsCount,
    subscription,
    member_count: membersCount,
  } = useSelectedWorkspaceContext();

  const { campaigns, isLoadingCampaigns } = useCampaigns();
  const { paymentSource, isLoadingPaymentSource } = usePaymentSource(
    subscription?.id,
  );

  const hasAccounts = accountsCount > 0;
  const hasCampaigns = campaigns?.length > 0;
  const hasTeamMembers = membersCount > 1; // There will always be at at least 1 member in the workspace ("owner")
  const hasPaymentSource = !!paymentSource;

  // Derived state
  const steps = [hasAccounts, hasCampaigns, hasTeamMembers, hasPaymentSource];
  const completedStepsCount = steps.filter(Boolean).length;
  const isCompleted = completedStepsCount === steps.length;
  const isLoadingProgress = isLoadingCampaigns || isLoadingPaymentSource;

  return {
    isCompleted,
    completedStepsCount,
    hasAccounts,
    hasCampaigns,
    hasTeamMembers,
    hasPaymentSource,
    // Loading state
    isLoadingProgress,
    isLoadingCampaigns,
    isLoadingPaymentSource,
  };
}
